import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { map } from "rxjs/operators";
import { recursosBecas } from "../recursos/interfaz";
import { core } from '@angular/compiler';
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class SeleccionService {

  constructor(private http: Http, private rutas: recursosBecas, private httpArchivos: HttpClient) { }

  personaCentralDocumento(cedula: string) {
    return this.http.get(this.rutas.rutasCentralPersona + "/personaPorDocumento/" + cedula).pipe(map(res => res.json()));
  }
  personaCentral2Documento(cedula: string) {
    return this.http.get("https://centralizada2.espoch.edu.ec/rutadinardap/obtenerpersona/" + cedula).pipe(map(res => res.json()));
  }
  personaCentralCorreo(correo: string) {
    return this.http.get('https://centralizada2.espoch.edu.ec/rutaCentral/objetopersonalizadodadoemail/' + correo).pipe(map(res => res.json()));
  }
  personaCentralId(idPersona: string) {
    return this.http.get(this.rutas.rutasCentralPersona + "/personaPorId/" + idPersona).pipe(map(res => res.json()));
  }
  personaCentralCargo(idPersona: string) {
    return this.http.get(this.rutas.rutasCentralPersona + "/personaCargo/" + idPersona).pipe(map(res => res.json()));
  }

  gestionOtros(opcion: number, param1: string) {
    return this.http.get(this.rutas.rutasPublico + "/getGetionAjustes/" + opcion + "/" + param1 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }
  gestionRoles(opcion: number, param1: string, param2: string) {
    return this.http.get(this.rutas.rutasPublico + "/getGetionRoles/" + opcion + "/" + param1 + "/" + param2 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }
  gestionUsuarios(opcion: number, param1: string, param2: string, param3: string) {
    return this.http.get(this.rutas.rutasPublico + "/getGetionUsuarios/" + opcion + "/" + param1 + "/" + param2 + "/" + param3 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }
  gestionPermisos(opcion: number, param1: string, param2: string, param3: string) {
    return this.http.get(this.rutas.rutasPublico + "/getGetionPermisos/" + opcion + "/" + param1 + "/" + param2 + "/" + param3 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }
  gestionBecas(opcion: number, param1: string, param2: string, param3: string) {
    return this.http.get(this.rutas.rutasPublico + "/getGetionBecas/" + opcion + "/" + param1 + "/" + param2 + "/" + param3 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }
  gestionRequisitos(opcion: number, param1: string, param2: string, param3: string) {
    return this.http.get(this.rutas.rutasPublico + "/getGetionRequisitos/" + opcion + "/" + param1 + "/" + param2 + "/" + param3 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }
  gestionPostulantes(opcion: number, param1: any, param2: any, param3: any, param4: any) {
    return this.http.get(this.rutas.rutasPublico + "/getGetionPostulantes/" + opcion + "/" + param1 + "/" + param2 + "/" + param3 + "/" + param4 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }
  gestionPsicologiaE(opcion: number, param1: string, param2: string, param3: string, param4: string) {
    return this.http.get(this.rutas.rutasPublico + "/getGetionPsicologiaE/" + opcion + "/" + param1 + "/" + param2 + "/" + param3 + "/" + param4 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }
  gestionEncuesta(opcion: number, param1: string, param2: string, param3: string, param4: string) {
    return this.http.get(this.rutas.rutasPublico + "/getGetionEncuesta/" + opcion + "/" + param1 + "/" + param2 + "/" + param3 + "/" + param4 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }

  gestionSocioEconomico(opcion: number, param1: string, param2: string, param3: string, param4: string) {
    return this.http.get(this.rutas.rutasPublico + "/getGestionSocioEconomico/" + opcion + "/" + param1 + "/" + param2 + "/" + param3 + "/" + param4 + "/na" + Math.floor(Math.random() * 1000)).pipe(map((res) => res.json()));
  }
  //BD - COD ESTUDIANTE - NOMBRE PERSONA QUE GENERAR CON GUIONES BAJO LOS ESPACIOS - Y EL CARGO QUE TIENE PERSONA CON GUION BAJO TAMBIEN LOS ESPACIOS
  gestionRecordAcademico(carrera: string, codEstudiante: string, nombAna: string, cargoAna: string) {
    return this.http.get(this.rutas.rutaRecordAcademico + `${carrera}/${codEstudiante}/15/${nombAna}/${cargoAna}`);
  }

  gestionRespuestaFicha(opcion: number, param1: string, param2: string, param3: string, param4: string, param5: string, param6: string, param7: string, param8: string,
    param9: string, param10: string, param11: string, param12: string, param13: string, param14: string, param15: string, param16: string, param17: string, param18: string) {

    return this.http.get(this.rutas.rutasPublico + "/getGetionRespFicha1/" + opcion + "/" + param1 + "/" + param2 + "/" + param3 + "/" + param4 + "/" + param5 + "/" + param6 + "/"
      + param7 + "/" + param8 + "/" + param9 + "/" + param10 + "/" + param11 + "/" + param12 + "/" + param13 + "/" + param14 + "/" + param15 + "/" + param16 + "/" + param17 + "/"
      + param18 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }


  obtenerGestionFichaEstudiante(opcion: number, param1: string, param2: string, param3: string, param4: string) {
    return this.http.get(this.rutas.rutasPublico + "/getGestionFichaEstudiantil/" + opcion + "/" + param1 + "/" + param2 + "/" + param3 + "/" + param4 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }


  gestionCarreras(opcion: number, param1: string, param2: string, param3: string) {
    return this.http.get(this.rutas.rutasMaster + "/getInformacionCarreras/" + opcion + "/" + param1 + "/" + param2 + "/" + param3 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }
  gestionMatricula(opcion: number, malla: string, param1: string, param2: string, param3: string) {
    return this.http.get(this.rutas.rutasMaster + "/getInformacionMatricula/" + opcion + "/" + malla + "/" + param1 + "/" + param2 + "/" + param3 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }
  gestionMatriculaDosNotas(opcion: number, malla: string, param1: string, param2: string, param3: string) {
    return this.http.get(this.rutas.rutasMaster + "/getMatriculaReglamentoDosNotas/" + opcion + "/" + malla + "/" + param1 + "/" + param2 + "/" + param3 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }
  gestionDatosPersonaMaster(opcion: number, param1: string, param2: string, param3: string) {
    return this.http.get(this.rutas.rutasMaster + "/getInformacionPersona/" + opcion + "/" + param1 + "/" + param2 + "/" + param3 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()));
  }

  gestionGruposCentral(opcion: number, param1: string, param2: string, param3: string) {
    return this.http.get(this.rutas.rutasCentralPersona + "/personaGrupo/" + opcion + "/" + param1 + "/" + param2 + "/" + param3).pipe(map(res => res.json()));
  }

  medicoHistoriaClinica(usuario) {
    return this.http.get(this.rutas.rutasMedico + "/getUsuarioActivo/" + usuario).pipe(map(res => res.json()))
  }
  medicohorarriosMedicos(opcion, rol) {
    return this.http.get(this.rutas.rutasMedico + "/getMedicosHorarios/" + opcion + "/" + rol + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()))
  }
  medicoExisteCita(cual, usuario, paciente, hora, dato1, dato2, dato3) {
    return this.http.get(this.rutas.rutasMedico + "/getExisteCitas/" + cual + "/" + usuario + "/" + paciente + "/" + hora + '/' + dato1 + '/' + dato2 + '/' + dato3 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()))
  }
  medicoTurnosMedicos(cual, dato1, dato2, dato3, dato4, dato5) {
    return this.http.get(this.rutas.rutasMedico + "/getTurnosMedico/" + cual + "/" + dato1 + "/" + dato2 + "/" + dato3 + "/" + dato4 + "/" + dato5 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()))
  }
  medicoRestringeFecha(usuario, fecha) {
    return this.http.get(this.rutas.rutasMedico + "/getRestringeFecha/" + usuario + "/" + fecha + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()))
  }
  medicoRestringeDias(usuario, dia) {
    return this.http.get(this.rutas.rutasMedico + "/getRestringeDias/" + usuario + "/" + dia + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()))
  }
  medicoCitasMedicoFecha(usuario, fecha, hora) {
    return this.http.get(this.rutas.rutasMedico + "/getCitasFechaMedico/" + usuario + "/" + fecha + "/" + hora + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()))
  }
  medicoExisteCitaFecha(paciente, inicio, fin) {
    return this.http.get(this.rutas.rutasMedico + "/getExisteCitasFecha/" + paciente + "/" + inicio + "/" + fin + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()))
  }
  medicoOtrosDatos(opcion, cond1, cond2) {
    return this.http.get(this.rutas.rutasMedico + "/getInfoOtros/" + opcion + "/" + cond1 + "/" + cond2 + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()))
  }
  medicoverUnMedico(usuario) {
    return this.http.get(this.rutas.rutasMedico + "/getUnMedico/" + usuario + "/na" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()))
  }
  medicoverProvincia(dato1, dato2, dato3) {
    return this.http.get(this.rutas.rutasMedico + "/getInfoCiudades/" + dato1 + "/" + dato2 + "/" + dato3 + "/" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()))
  }
  medicoverHCE(opc, dato1, dato2, dato3) {
    return this.http.get(this.rutas.rutasMedico + "/getCitasPaciente/" + opc + "/" + dato1 + "/" + dato2 + "/" + dato3 + "/" + Math.floor((Math.random() * 1000))).pipe(map(res => res.json()))
  }



  //SERVICIO QUE OBTIENE EL TOKEN PARA EL DRIVE
  postTokenPDF = () => {
    let headers = new Headers();
    const vecPDF = {
      idAplicacion: this.rutas.idAplicacion,
      jwtsecret: this.rutas.claveAplicacion,
      activo: 'true'
    }
    headers.append('Content-Type', 'application/json');
    return this.http.post(this.rutas.rutaGestionArchivos + 'getTokenAplicacion', vecPDF, { headers: headers }).pipe(map(res => res.json()))
  };
  //OBTENER EL TOKEN PARA EL CONSUMO DE SERVICIOS DE TTHH
  getAccesoTokenTTHH = () => {
    const vecPersona = {
      apiKey: "4p1k3y_extDTH@"
    };
    return this.http.post(this.rutas.rutasCentralPersona + '/obtenerTokenTTHH', vecPersona);
  };
  //RETORNA INFORMACIÓN DE UN EMPLEADO
  getCargoDependenciaTTHH = (cedula: string, claveServicio: any) => {
    const vecPersona = {
      perCedula: cedula,
      acceso: claveServicio
    }
    return this.httpArchivos.post<any>(this.rutas.rutasCentralPersona + '/obtenerCargoTTHH', vecPersona);
  };
  //BUSCAMOS SI TIENE MATRÍCULA EN POSTGRADO
  getEstudiantePosgrado(cedula: string) {
    return this.http.get(this.rutas.RUTA_ESTUDIANTE_POSGRADO + cedula);
  }

}
